import React from 'react';

import { CustomSVGProps } from './CustomSVGProps.types';

export function IconBin48(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="48"
            height="48"
            viewBox="0 0 48 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="delete">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.97473 6H41.0254L40.146 41.1749C40.0511 44.9716 36.946 48 33.1482 48H16.8519C13.0541 48 9.94902 44.9716 9.85411 41.1749L8.97473 6ZM11.0254 8L11.8535 41.125C11.9213 43.8369 14.1392 46 16.8519 46H33.1482C35.8609 46 38.0788 43.8368 38.1466 41.125L38.9747 8H11.0254Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M19 13V41H17L17 13H19Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M26 13V41H24L24 13H26Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M33 13V41H31L31 13H33Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M43 8L7 8L7 6L43 6V8Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M16 3C16 1.34315 17.3431 0 19 0H31C32.6569 0 34 1.34315 34 3V8H16V3ZM19 2C18.4477 2 18 2.44772 18 3V6H32V3C32 2.44772 31.5523 2 31 2H19Z"
                fill={props.fill || 'currentColor'}
            />
        </svg>
    );
}

export function IconBin24(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="delete">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M3.94287 4H20.0571L19.1559 20.2219C19.0381 22.3415 17.2849 24 15.162 24H8.83793C6.71499 24 4.96185 22.3415 4.84409 20.2219L3.94287 4ZM6.05707 6L6.84101 20.1109C6.89989 21.1708 7.77646 22 8.83793 22H15.162C16.2235 22 17.1 21.1708 17.1589 20.1109L17.9429 6H6.05707Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11 8L11 20H9L9 8H11Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M15 8L15 20H13L13 8H15Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M22 6L2 6L2 4L22 4V6Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7 2C7 0.895431 7.89543 0 9 0H15C16.1046 0 17 0.895431 17 2V4C17 5.10457 16.1046 6 15 6H9C7.89543 6 7 5.10457 7 4V2ZM15 2H9V4H15V2Z"
                fill={props.fill || 'currentColor'}
            />
        </svg>
    );
}

export function IconBin16(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="delete">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M1.90491 3H14.095L13.1612 13.2716C13.0207 14.8168 11.7251 16 10.1735 16H5.82637C4.27476 16 2.97917 14.8168 2.83869 13.2716L1.90491 3ZM4.09497 5L4.83048 13.0905C4.8773 13.6056 5.30917 14 5.82637 14H10.1735C10.6907 14 11.1226 13.6056 11.1694 13.0905L11.9049 5H4.09497Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M15 5L1 5L1 3L15 3V5Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M4 1C4 0.447715 4.44772 0 5 0H11C11.5523 0 12 0.447715 12 1V4C12 4.55228 11.5523 5 11 5H5C4.44772 5 4 4.55228 4 4V1ZM6 2V3H10V2H6Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M9 6L9 13H7L7 6H9Z"
                fill={props.fill || 'currentColor'}
            />
        </svg>
    );
}
